import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Logo from 'src/app/components/Logo';

const TopBarMobileDrawer = ({
  menuResponsive,
  toggleDrawer,
  listMenu,
  switchRoute,
  setMenuResponsive,
  canShowDropdownMenus,
  openManageMobile,
  setOpenManageMobile,
  isManageActive,
  isAccountant,
  isSale,
  renderMobileMenuItem,
  isAdmin,
  openStatistics,
  setOpenStatistics,
  isStatisticsActive,
  mobileStatisticsItems,
  mobileAdminItems,
  isAgency,
  isStaff,
  isUser,
  isTechnician,
  openDeviceManage,
  setOpenDeviceManage,
  isDevicePathActive,
  mobileDeviceItems,
  isPathActive
}) => (
  <Drawer
    className="mobile-drawer"
    open={menuResponsive}
    anchor="left"
    onClose={toggleDrawer(false)}
    PaperProps={{ style: { width: '85vw' } }}
  >
    <div role="presentation">
      <Box display="flex" justifyContent="center" padding="16px 0">
        <Logo />
      </Box>

      <List>
        {listMenu.map(menu => (
          <ListItem
            button
            key={menu.value}
            onClick={() => {
              switchRoute(menu.link, menu.query);
              setMenuResponsive(false);
            }}
          >
            <ListItemText
              primary={menu.label}
              primaryTypographyProps={{
                style: {
                  color: isPathActive(menu.link) ? '#D9042F' : '#475461',
                  fontWeight: isPathActive(menu.link) ? 600 : 400
                }
              }}
            />
          </ListItem>
        ))}

        {canShowDropdownMenus && (
          <ListItem button onClick={() => setOpenManageMobile(value => !value)}>
            <ListItemText
              primary="Quản trị"
              primaryTypographyProps={{
                style: {
                  color: isManageActive ? '#D9042F' : '#475461',
                  fontWeight: isManageActive ? 600 : 400
                }
              }}
            />
            <ExpandMoreIcon
              style={{
                transform: openManageMobile ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: '0.25s',
                color: isManageActive ? '#D9042F' : '#475461'
              }}
            />
          </ListItem>
        )}

        {(isAccountant || isSale) &&
          renderMobileMenuItem(
            {
              label: 'Quản trị kinh doanh',
              route: '/manage/sales-orders'
            },
            16
          )}

        <Collapse in={openManageMobile} timeout={250} unmountOnExit>
          <List component="div" disablePadding>
            {isAdmin && (
              <>
                <ListItem
                  button
                  style={{ paddingLeft: 32 }}
                  onClick={() => setOpenStatistics(value => !value)}
                >
                  <ListItemText
                    primary="Thống kê"
                    primaryTypographyProps={{
                      style: {
                        fontWeight: isStatisticsActive ? 600 : 400,
                        color: isStatisticsActive ? '#D9042F' : '#475461'
                      }
                    }}
                  />
                  <ExpandMoreIcon
                    style={{
                      transform: openStatistics ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: '0.25s',
                      color: isStatisticsActive ? '#D9042F' : '#475461'
                    }}
                  />
                </ListItem>

                <Collapse in={openStatistics} timeout={250} unmountOnExit>
                  <List component="div" disablePadding>
                    {mobileStatisticsItems.map(item =>
                      renderMobileMenuItem(item, 48, true)
                    )}
                  </List>
                </Collapse>

                {mobileAdminItems.map(item => renderMobileMenuItem(item))}
              </>
            )}

            {(isAdmin || isAgency || isStaff || isUser || isTechnician) &&
              !isAccountant &&
              !isSale && (
                <>
                  <ListItem
                    button
                    style={{ paddingLeft: 32 }}
                    onClick={() => setOpenDeviceManage(value => !value)}
                  >
                    <ListItemText
                      primary="Quản trị thiết bị"
                      primaryTypographyProps={{
                        style: {
                          fontWeight: isDevicePathActive ? 600 : 400,
                          color: isDevicePathActive ? '#D9042F' : '#475461'
                        }
                      }}
                    />
                    <ExpandMoreIcon
                      style={{
                        transform: openDeviceManage
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                        transition: '0.25s',
                        color: isDevicePathActive ? '#D9042F' : '#475461'
                      }}
                    />
                  </ListItem>

                  <Collapse in={openDeviceManage} timeout={250} unmountOnExit>
                    <List component="div" disablePadding>
                      {mobileDeviceItems.map(item =>
                        renderMobileMenuItem(item, 48, true)
                      )}
                    </List>
                  </Collapse>
                </>
              )}
          </List>
        </Collapse>
      </List>
    </div>
  </Drawer>
);

TopBarMobileDrawer.propTypes = {
  menuResponsive: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  listMenu: PropTypes.array.isRequired,
  switchRoute: PropTypes.func.isRequired,
  setMenuResponsive: PropTypes.func.isRequired,
  canShowDropdownMenus: PropTypes.bool.isRequired,
  openManageMobile: PropTypes.bool.isRequired,
  setOpenManageMobile: PropTypes.func.isRequired,
  isManageActive: PropTypes.bool.isRequired,
  isAccountant: PropTypes.bool.isRequired,
  isSale: PropTypes.bool.isRequired,
  renderMobileMenuItem: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  openStatistics: PropTypes.bool.isRequired,
  setOpenStatistics: PropTypes.func.isRequired,
  isStatisticsActive: PropTypes.bool.isRequired,
  mobileStatisticsItems: PropTypes.array.isRequired,
  mobileAdminItems: PropTypes.array.isRequired,
  isAgency: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isUser: PropTypes.bool.isRequired,
  isTechnician: PropTypes.bool.isRequired,
  openDeviceManage: PropTypes.bool.isRequired,
  setOpenDeviceManage: PropTypes.func.isRequired,
  isDevicePathActive: PropTypes.bool.isRequired,
  mobileDeviceItems: PropTypes.array.isRequired,
  isPathActive: PropTypes.func.isRequired
};

export default TopBarMobileDrawer;
